(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-list"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      var splide = new Splide('#category-slider', {
        type: 'slide',
        perPage: 1,
        gap: '20px',
        pagination: false,
        arrows: false
      });

      splide.on('mounted move', function () {
        var totalSlides = splide.length;
        var currentIndex = splide.index + 1;
        var progressWidth = (currentIndex / totalSlides) * 100;
        document.querySelector('.custom-progress-bar').style.width = progressWidth + '%';
      });

      splide.mount();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
